import moment from 'moment'

/**
 * 尼日利亚业务时间工具（Africa/Lagos，WAT UTC+1，无夏令时）。
 *
 * 后台表单录入日期需统一按 WAT 写入；App/服务端校验均使用同一时区。
 * 注：本项目仅依赖 moment，未引入 moment-timezone；
 * WAT 固定 UTC+1 且无夏令时，这里直接用偏移量换算，结果与 Africa/Lagos 一致。
 */

const WAT_OFFSET_MINUTES = 60 // UTC+1

function toWat(date = new Date()) {
  const local = moment(date)
  const utc = local.utc()
  return utc.add(WAT_OFFSET_MINUTES, 'minutes')
}

export const WAT_ZONE_LABEL = '尼日利亚时间 (Africa/Lagos, UTC+1)'

/**
 * 获取当前尼日利亚墙钟时间，格式 'YYYY-MM-DD HH:mm:ss'，可直接赋值给 a-date-picker。
 */
export function watNow(pattern = 'YYYY-MM-DD HH:mm:ss') {
  return toWat().format(pattern)
}

/**
 * 在当前尼日利亚时间上加偏移天数，返回同格式字符串。
 */
export function watNowAddDays(days, pattern = 'YYYY-MM-DD HH:mm:ss') {
  return toWat().add(days, 'days').format(pattern)
}

/**
 * 格式化指定日期为尼日利亚时间字符串。
 */
export function formatToWat(date, pattern = 'YYYY-MM-DD HH:mm:ss') {
  if (date == null || date === '') return null
  return toWat(date).format(pattern)
}